"use client";

import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import {
  useAccount,
  useBalance,
  useDisconnect,
  useNetwork,
  useSwitchNetwork,
} from "wagmi";

import { freeGasApi } from "@/apis";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover";
import { handleErrorGasFree } from "@/lib/contractHelper";
import { compactAddress, numberToHex } from "@/lib/function";
import { accountSelector } from "@/store/account/account.slice";
import { authActions } from "@/store/actions";
import { PopoverInfoWallet } from "./PopoverInfoWallet";

declare global {
  interface Window {
    ethereum?: any;
  }
}
function ProfileConnect({
  onCancelMenu = () => {},
}: {
  onCancelMenu?: () => void;
}) {
  const dispatch = useDispatch();
  const { account } = useSelector(accountSelector);

  const { connector, address } = useAccount();
  const { disconnect } = useDisconnect();
  const { chain } = useNetwork() as any;

  const [connectorId, setConnectorId] = useState<string | null>(null);
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const [loadingGetFreeGas, setLoadingGetFreeGas] = useState(false);
  const [curentChains, setCurrentChains] = useState(null);

  const {
    chains,
    switchNetwork,
    isLoading: isLoadingSwitch,
  } = useSwitchNetwork({
    throwForSwitchChainNotSupported: true,
    onSuccess() {
      setCurrentChains(null);
    },
    onError(error: any) {
      (async () => {
        if (error.cause?.code === -32603) {
          try {
            await window?.ethereum?.request({
              method: "wallet_addEthereumChain",
              params: [
                {
                  chainId: numberToHex(curentChains?.id),
                  rpcUrls: curentChains?.rpcUrls?.default?.http,
                  chainName: curentChains?.name,
                  nativeCurrency: curentChains?.nativeCurrency,
                  iconUrls: [curentChains?.icon],
                },
              ],
            });
          } catch (e) {
            console.log(e);
          }
        }
      })();
    },
  }) as any;

  const { refetch } = useBalance({
    address,
    onSuccess(data) {
      dispatch(authActions.self.loadBalanceGas(data));
    },
  });

  const handleGetFreeGas = async () => {
    try {
      setLoadingGetFreeGas(true);

      await freeGasApi.getFreeGas({
        receiverAddr: address,
        chainId: numberToHex(chain.id),
      });

      await refetch();
      toast.success("Bạn đã nhận DAP Credits thành công");
    } catch (err) {
      const message = await handleErrorGasFree({
        key: err?.cause?.reason,
      });
      toast.error(message);
    } finally {
      setLoadingGetFreeGas(false);
    }
  };

  const handleOpenProfile = (e: React.MouseEvent) => {
    if ((e.target as HTMLElement).id === "gas") {
      handleGetFreeGas();
    }
    // else {
    //   onCancelMenu();
    //   setTimeout(() => {
    //     dispatch(alertActions.setShowProfileModal(true));
    //   }, 500);
    // }
  };

  useEffect(() => {
    if (connector?.id) {
      setConnectorId(connector.id);
    }
  }, [connector]);

  const isRightWallet =
    account?.walletAddress?.toLocaleLowerCase() ===
    address?.toLocaleLowerCase();

  return (
    <Popover
      onOpenChange={() => {
        setIsPopoverOpen(false);
      }}
    >
      <PopoverTrigger asChild>
        <div className="flex items-center gap-2 cursor-pointer  bg-gray-100 rounded-[99px] pr-2">
          {!!connectorId && (
            <img
              className="w-7 h-7"
              alt=""
              src={`/icons/wallets/${connectorId}.svg`}
            />
          )}
          <span className="text-sm text-gray-700">
            {isRightWallet ? (
              <span>{compactAddress(address, 7)}</span>
            ) : (
              <span className="text-red-500 underline text-xs">
                Địa chỉ ví không hợp lệ
              </span>
            )}
          </span>
          <img className="" src="/icons/arrow_down.svg" alt="" />
        </div>
      </PopoverTrigger>
      <PopoverContent align="end">
        <PopoverInfoWallet />
      </PopoverContent>
    </Popover>
  );
}

export default ProfileConnect;
